"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.formatCurrencyToNumber = exports.formatPurseWithoutCurrency = exports.formatPurse = exports.formatNumber = exports.formatCurrencyShortened = void 0;

var _currencyFormatter = _interopRequireDefault(require("currency-formatter"));

var _numeral = _interopRequireDefault(require("numeral"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const formatCurrency = (value, code = "USD", precision = 2) => _currencyFormatter.default.format(value, {
  code,
  precision
});

const formatCurrencyShortened = (value, code = "USD", precision = 0) => _currencyFormatter.default.format(value, {
  code,
  precision
});

exports.formatCurrencyShortened = formatCurrencyShortened;

const formatNumber = value => (0, _numeral.default)(value).format("0.00");

exports.formatNumber = formatNumber;

const formatPurse = value => {
  if (value >= 1000) {
    return value % 1000 !== 0 ? (0, _numeral.default)(value).format("$0.0a") : (0, _numeral.default)(value).format("$0a");
  }

  return (0, _numeral.default)(value).format("$0");
};

exports.formatPurse = formatPurse;

const formatPurseWithoutCurrency = value => {
  if (value >= 1000) {
    return value % 1000 !== 0 ? (0, _numeral.default)(value).format("0.0a") : (0, _numeral.default)(value).format("0a");
  }

  return (0, _numeral.default)(value).format("0.00a");
};

exports.formatPurseWithoutCurrency = formatPurseWithoutCurrency;

const formatCurrencyToNumber = value => +value.replace(/\$|,/g, "");

exports.formatCurrencyToNumber = formatCurrencyToNumber;
var _default = formatCurrency;
exports.default = _default;